import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingLinkClick = ({ data, event, }) => {
    const EVENT_DATA = {
        ...data,
        event,
    };
    const thorEvent = useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: EVENT_DATA,
    });
    return () => thorEvent();
};
